import React from "react";
import { UserGroupIcon } from "@heroicons/react/24/outline";

const Portfolio = () => {
  const projects = [
    {
      title: "Interactive Grammar Course",
      description:
        "Comprehensive grammar course with 50+ interactive lessons covering all major grammar topics.",
      image: "/images/hero-student.png",
      tags: ["Grammar", "Interactive", "Beginner"],
      students: "500+",
      rating: 4.9,
    },
    {
      title: "IELTS Speaking Masterclass",
      description:
        "Complete IELTS speaking preparation with mock tests and personalized feedback.",
      image: "/images/hero-student.png",
      tags: ["IELTS", "Speaking", "Advanced"],
      students: "300+",
      rating: 4.8,
    },
    {
      title: "Business English Bootcamp",
      description:
        "Professional English skills for workplace communication and career advancement.",
      image: "/images/hero-student.png",
      tags: ["Business", "Professional", "Intermediate"],
      students: "200+",
      rating: 4.9,
    },
    {
      title: "Vocabulary Builder Pro",
      description:
        "Advanced vocabulary building course with 1000+ essential words and phrases.",
      image: "/images/hero-student.png",
      tags: ["Vocabulary", "Memory", "All Levels"],
      students: "800+",
      rating: 4.7,
    },
  ];

  const achievements = [
    { number: "1200+", label: "Students Taught", icon: "👨‍🎓" },
    { number: "50+", label: "Courses Created", icon: "📚" },
    { number: "4.9/5", label: "Average Rating", icon: "⭐" },
    { number: "98%", label: "Success Rate", icon: "🎯" },
  ];

  return (
    <section
      id="portfolio"
      className="py-20 bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 animate-gradient"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl lg:text-6xl font-bold font-display mb-6">
            My <span className="gradient-text">Portfolio</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore my successful courses and teaching materials that have
            helped thousands of students
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl shadow-2xl overflow-hidden card-hover"
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >
              <div className="relative">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover"
                />
                <div
                  className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full"
                  data-aos="zoom-in"
                  data-aos-delay={index * 200 + 300}
                >
                  <div className="flex items-center space-x-1">
                    <span className="text-yellow-500">⭐</span>
                    <span className="font-semibold text-gray-800">
                      {project.rating}
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-8">
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-800 px-3 py-1 rounded-full text-sm font-semibold"
                      data-aos="fade-right"
                      data-aos-delay={index * 200 + 400 + idx * 100}
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <h3
                  className="text-2xl font-bold font-display text-gray-800 mb-3"
                  data-aos="fade-up"
                  data-aos-delay={index * 200 + 500}
                >
                  {project.title}
                </h3>
                <p
                  className="text-gray-600 leading-relaxed mb-6"
                  data-aos="fade-up"
                  data-aos-delay={index * 200 + 600}
                >
                  {project.description}
                </p>

                <div
                  className="flex items-center justify-between"
                  data-aos="fade-up"
                  data-aos-delay={index * 200 + 700}
                >
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-1">
                      <UserGroupIcon className="w-5 h-5 text-indigo-600" />
                      <span className="text-gray-700 font-semibold">
                        {project.students}
                      </span>
                    </div>
                  </div>
                  <button className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-6 py-2 rounded-full hover:from-indigo-700 hover:to-purple-700 transition-all transform hover:scale-105 font-semibold">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Achievement Stats */}
        <div
          className="bg-white rounded-3xl shadow-2xl p-8"
          data-aos="fade-up"
          data-aos-delay="800"
        >
          <h3 className="text-3xl font-bold font-display text-center text-gray-800 mb-12">
            Teaching Achievements
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {achievements.map((stat, index) => (
              <div
                key={index}
                className="text-center"
                data-aos="zoom-in"
                data-aos-delay={1000 + index * 150}
              >
                <div className="text-4xl mb-3">{stat.icon}</div>
                <div className="text-3xl font-bold font-display gradient-text mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
